import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { getUserRole } from '../../../auth/login/store';
import { adminRoles } from '../../../constants/permittedRoles';
import { Button } from '../../../shared/button/Button';
import { enquireOpinionStarted } from '../../my-opinions/store';
import styles from '../Analytics.module.scss';

interface UnauthorisedOpinionProps {
    opinionId: number;
}

export const UnauthorisedOpinion: React.FC<UnauthorisedOpinionProps> = ({ opinionId }) => {
    const dispatch = useAppDispatch();
    const userRole = useAppSelector(getUserRole);
    const isAdminUser = adminRoles.includes(userRole!);

    const messageOne = useMemo(() => isAdminUser ? 'If you would like to know more about this opinion and the cost associated with accessing this content,' : 'If you think this opinion would be of interest to your company, please reach out to your team administrator', [isAdminUser]);
    const messageTwo = useMemo(() => isAdminUser ? 'please click the \'Enquire\' button below to send an enquiry email and someone from our team will be in touch' : 'They can use this page to send an enquiry via the button below and someone from our team will be in touch', [isAdminUser]);

    const sendEnquiry = useCallback(() => { dispatch(enquireOpinionStarted(opinionId)); }, [dispatch, opinionId]);

    return (
        <div className={styles.unauthorisedOpinionWrapper}>
            <div className={styles.warningHeader}>You do not currently have access to view this opinion</div>
            <div className={styles.unauthorisedOpinionAccess}>{messageOne}</div>
            <div className={styles.unauthorisedOpinionAccess}>{messageTwo}</div>
            {isAdminUser &&
                <div className={styles.enquireButtonWrapper}>
                    <Button label='Enquire' onClick={sendEnquiry} />
                </div>
            }
        </div>
    );
};
